export const withPathPrefix = (url) => {
    const prefix = window.location.pathname.startsWith(process.env.ROUTE_PREFIX)
        ? process.env.ROUTE_PREFIX
        : "";
    return prefix + (url.substring(0, 1) === "/" ? "" : "/") + url;
};
/**
 * Returns a Polish phrase with correct plural form and optional # placeholder for count.
 *
 * @param count number value
 * @param forms
 * Example:
 * pluralize(3, ["# dzień", "# dni", "# dni"]) => "3 dni"
 * pluralize(1, ["# osoba wybrana", "# osoby wybrane", "# osób wybranych"])
 * => "1 osoba wybrana"
 */
export const pluralize = (count, forms) => {
    const mod10 = count % 10;
    const mod100 = count % 100;
    let form;
    if (count === 1)
        form = forms[0];
    else if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14))
        form = forms[1];
    else
        form = forms[2];
    // Replace # with count
    if (form.includes("#")) {
        return form.replace("#", String(count));
    }
    return form;
};
